import React from "react";
import { TableHeader } from "./TableHeader";
import { TableFilters } from "./TableFilters";
import { Pagination } from "../models/response/payment-list-response";

type ColumnConfig = {
  key: string;
  label: string;
  render?: (item: any) => React.ReactNode;
};

type ListTableProps = {
  page: number;
  setPage: (page: number) => void;
  statusFilter: string;
  loading: boolean;
  pagination: Pagination;
  error: any;
  list: Array<any>;
  setStatusFilter: (statusFilter: string) => void;
  title: string;
  columns: ColumnConfig[];
};

export const ListTable = ({
  page,
  setPage,
  statusFilter,
  loading,
  pagination,
  error,
  list,
  setStatusFilter,
  title,
  columns,
}: ListTableProps) => {
  return (
    <div className="list-container">
      <div className="max-width">
        <h1 className="title">{title}</h1>
        <TableFilters
          statusFilter={statusFilter}
          onStatusFilter={setStatusFilter}
        />
        <div className="table-container">
          <div className="overflow-x-auto">
            <table className="table">
              <thead className="table-header">
                <tr>
                  {columns.map((column) => (
                    <TableHeader key={column.key} label={column.label} />
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      Loading...
                    </td>
                  </tr>
                ) : error ? (
                  <tr>
                    <td
                      colSpan={columns.length}
                      className="text-danger text-center"
                    >
                      {error}
                    </td>
                  </tr>
                ) : list && list.length > 0 ? (
                  list.map((item) => (
                    <tr key={item.id} className="table-row">
                      {columns.map((column) => (
                        <td key={column.key} className="table-cell">
                          {column.render
                            ? column.render(item)
                            : item[column.key]}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {pagination?.totalPages > 1 && (
            <nav>
              <ul className="pagination justify-content-center">
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => setPage(page - 1)}
                  >
                    Previous
                  </button>
                </li>
                {Array.from({ length: pagination.totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${page === i + 1 ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    page === pagination.totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => setPage(page + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};
